__turbopack_context__.v({
  "g2k": "GoodToKnow-module-scss-module__SccLQq__g2k",
});
